import { useToggle } from 'usehooks-ts';
import useOnPathChange from './onPathChange';

export function useToggleAndCloseOnPathChanged(): [boolean, () => void, (isOpen: boolean) => void] {
    const [isOpen, toggleDrawer, setOpenDrawer] = useToggle();

    useOnPathChange(() => {
        setOpenDrawer(false);
    });

    return [isOpen, toggleDrawer, setOpenDrawer];
}
